import {createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = 'http://localhost:5000/api/stock/';

export const portfolioApi = createApi({
    reducerPath: "portfolioDetails",
    baseQuery: fetchBaseQuery({baseUrl}),
    endpoints: (builder) => ({
        portfolioprices: builder.query({
            query: (user_id, ...patch) => (
                {url: `/fetch-portfolio-details`, method: "POST", body: patch}
            )
        }),
    })
})

export const {usePortfoliopricesQuery} = portfolioApi;